import { DirectusItem, DirectusChannelItem } from '../app/hooks/UseReadFeedContent';
import { SavedPostData } from '../app/context/MyListContext';

type DirectusItemTranslationField = 'title' | 'description' | 'content';
type DirectusChannelTranslationField = 'name';
type TranslatableField = DirectusItemTranslationField | DirectusChannelTranslationField;

export function getTranslation(
  item: DirectusItem | SavedPostData['posts_id'],
  field: DirectusItemTranslationField,
  languageTag: string
): string;
export function getTranslation(
  item: DirectusChannelItem,
  field: DirectusChannelTranslationField,
  languageTag: string
): string;

export function getTranslation(
  item: DirectusItem | DirectusChannelItem | SavedPostData['posts_id'],
  field: TranslatableField,
  languageTag: string
): string {
  if (!item) {
    return '';
  }
  const translations = item.translations ?? [];

  //DirectusItem
  if ('content' in item) {
    const translation = translations.find((t) => t?.languages_code?.code === languageTag);
    return (
      translation?.[field as keyof typeof translation]?.toString() ??
      item[field as keyof typeof item]?.toString() ??
      ''
    );
  }

  //DirectusChannelItem
  if ('name' in item) {
    const translation = translations.find((t) => t?.languages_code?.code === languageTag);
    if (translation && 'name' in translation) {
      return translation.name ?? '';
    }
    return item.name ?? '';
  }

  return '';
}

export function translateItems<T extends DirectusItem | DirectusChannelItem>(
  items: T[],
  field: TranslatableField,
  languageTag: string
): string[] {
  return items.map((item) => {
    if (field === 'name') {
      // DirectusChannelItem
      return getTranslation(
        item as DirectusChannelItem,
        field as DirectusChannelTranslationField,
        languageTag
      );
    } else {
      // DirectusItem
      return getTranslation(item as DirectusItem, field, languageTag);
    }
  });
}
